module.exports = __webpack_public_path__ + "img/interface-comment.872191d.svg";